const CLOCK = /^(\d+):(\d{2})$/;

export function isVoiceClock(value) {
  return typeof value === "string" && CLOCK.test(value.trim());
}

export function formatSecondsAsClock(totalSeconds) {
  const whole = Math.max(0, Math.round(Number(totalSeconds) || 0));
  const minutes = Math.floor(whole / 60);
  const seconds = whole % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/** "2:10" stays "2:10". A plain number is treated as decimal minutes. */
export function formatVoiceClock(value) {
  if (value == null || value === "") return "—";
  if (isVoiceClock(value)) return value.trim();

  const minutes = Number(value);
  if (Number.isNaN(minutes)) return "—";
  return formatSecondsAsClock(minutes * 60);
}

/** Clock strings are minutes and seconds. Plain numbers are decimal minutes. */
export function voiceClockToSeconds(value) {
  if (value == null || value === "") return 0;
  if (isVoiceClock(value)) {
    const match = value.trim().match(CLOCK);
    return Number(match[1]) * 60 + Number(match[2]);
  }

  const minutes = Number(value);
  if (!Number.isFinite(minutes)) return 0;
  return Math.round(minutes * 60);
}

export function voiceUsagePercent(used, included) {
  const includedSeconds = voiceClockToSeconds(included);
  if (!includedSeconds) return 0;
  return Math.round((voiceClockToSeconds(used) / includedSeconds) * 100);
}
